// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/Images/bigbtn.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP-Nuebit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}


.mobile-pop{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: white;
}

.mpop-close{
    padding: 5px;
    cursor: pointer;
}

.mpop-close img{
    height: 40px;
}

.mpop-name{
    font-family: PP-NueBit;
font-size: 45px;
/* font-weight: 700; */
letter-spacing: 0em;
text-align: center; 
}
.mpop-name p{
    margin: 7px 0;
}

.mpop-bottom h1{
    font-family: PP-Nuebit;
    text-align: center;
    margin:20px;
    font-size: 45px;
    align-self: center;
}

.mpop-top{
    background: #DECCE5;
    /* height: 55vh; */
    width: 100%;
}

.mpop-menu{
    display: flex;
    justify-content: space-around;
    font-family: PP-NueBit;
font-size: 25px;
line-height: 13px;
letter-spacing: 0em;
text-align: center;

}

.mpop-menu div{
    width: 50%;
}

.mpop-menu div p{
    /* width: 50%; */
    margin: 10px 0px;
}

.mpop-nft img{
    /* height: 32vh; */
    width: 30vh;
}

.mpop-bottom{
    /* height: 30vh; */
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 2vh;
    background-color: white;
}

.mpop-details{
    text-align: left;
}

.mpop-btn{
    width: 90%;
    align-self: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    color: white;
    font-family: PP-NueBit;
font-size: 25px;
/* font-weight: 700; */
line-height: 11px;
letter-spacing: 0em;
}

.mpop-btn p{
    margin-block-start: 1.1em;
}

.mpop-desc-title{
    font-family: 'N27';
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    /* line-height: 19px; */
    margin: 0;
}

.mpop-descriptions {
    font-family: 'N27';
    font-style: italic;
    font-weight: 700;
    font-size: 14px;
    line-height: 27px;
    margin: 0 0px 20px 0;
    /* width: 95%; */
}

`, "",{"version":3,"sources":["webpack://./src/components/CaPopupMob/CaPopupMob.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4CAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,4CAA8C;AAClD;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B,eAAe;AACf,sBAAsB;AACtB,mBAAmB;AACnB,kBAAkB;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;AAC1B,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,kBAAkB;;AAElB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,yDAAuD;IACvD,YAAY;IACZ,sBAAsB;AAC1B,eAAe;AACf,sBAAsB;AACtB,iBAAiB;AACjB,mBAAmB;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB","sourcesContent":["@font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n\n@font-face {\n    font-family: N27;\n    src: url(\"../../assets/Fonts/N27-Regular.otf\");\n}\n\n\n.mobile-pop{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100vw;\n    height: 100vh;\n    background-color: white;\n}\n\n.mpop-close{\n    padding: 5px;\n    cursor: pointer;\n}\n\n.mpop-close img{\n    height: 40px;\n}\n\n.mpop-name{\n    font-family: PP-NueBit;\nfont-size: 45px;\n/* font-weight: 700; */\nletter-spacing: 0em;\ntext-align: center; \n}\n.mpop-name p{\n    margin: 7px 0;\n}\n\n.mpop-bottom h1{\n    font-family: PP-Nuebit;\n    text-align: center;\n    margin:20px;\n    font-size: 45px;\n    align-self: center;\n}\n\n.mpop-top{\n    background: #DECCE5;\n    /* height: 55vh; */\n    width: 100%;\n}\n\n.mpop-menu{\n    display: flex;\n    justify-content: space-around;\n    font-family: PP-NueBit;\nfont-size: 25px;\nline-height: 13px;\nletter-spacing: 0em;\ntext-align: center;\n\n}\n\n.mpop-menu div{\n    width: 50%;\n}\n\n.mpop-menu div p{\n    /* width: 50%; */\n    margin: 10px 0px;\n}\n\n.mpop-nft img{\n    /* height: 32vh; */\n    width: 30vh;\n}\n\n.mpop-bottom{\n    /* height: 30vh; */\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 2vh;\n    background-color: white;\n}\n\n.mpop-details{\n    text-align: left;\n}\n\n.mpop-btn{\n    width: 90%;\n    align-self: center;\n    background-image: url(\"../../assets/Images/bigbtn.png\");\n    color: white;\n    font-family: PP-NueBit;\nfont-size: 25px;\n/* font-weight: 700; */\nline-height: 11px;\nletter-spacing: 0em;\n}\n\n.mpop-btn p{\n    margin-block-start: 1.1em;\n}\n\n.mpop-desc-title{\n    font-family: 'N27';\n    font-style: normal;\n    font-weight: bold;\n    font-size: 13px;\n    /* line-height: 19px; */\n    margin: 0;\n}\n\n.mpop-descriptions {\n    font-family: 'N27';\n    font-style: italic;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 27px;\n    margin: 0 0px 20px 0;\n    /* width: 95%; */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
